// react
import React, { PropsWithChildren } from "react";

import css from "./DatePicker.module.scss";

interface DayProps {
	isActiveDay: boolean;
	isActiveMonth: boolean;
	style: React.CSSProperties;
	onClick: (date: string) => void;
	date: string;
}

const Day = ({
	isActiveDay = false,
	isActiveMonth = true,
	style = {},
	onClick,
	date,
	children,
}: PropsWithChildren<DayProps>) => {
	const classes = [css.day, "day"];

	if (isActiveDay) {
		classes.push(...["active-day", css.isActive]);
	}

	if (!isActiveMonth) {
		classes.push(...["non-active", css.nonActive]);
	}

	return (
		<div onClick={() => onClick(date)} className={classes.join(" ")} style={style}>
			<div
				style={{
					width: style.width && parseInt(style.width.toString()) - 10,
					height: style.height && parseInt(style.height.toString()) - 5,
					left: 5,
					top: 0,
				}}
				className={`inner-box ${css.innerBox}`}
			>
				{children}
			</div>
		</div>
	);
};

export default Day;
